module.exports = __webpack_public_path__ + "static/media/protein-top.b8d069c1.png";